/**
 * Content carousel (slider) with extensive options to control behaviour and appearance
 * @requires https://swiperjs.com/
 */
export default (() => {
  const carousels = document.querySelectorAll('[data-swiper]');
  if (carousels.length === 0) return;

  carousels.forEach((value, index) => {
    let options, images;

    if (value.dataset.swiper !== undefined && value.dataset.swiper !== '') {
      options = JSON.parse(value.dataset.swiper);
      images = options?.thumbnails?.images;
    }

    const swiper = new Swiper(value, options);

    // Data layer slideChange listener
    swiper.on('slideChange', () => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const headingElement = activeSlide.querySelector('h2, h3, h4, h5, h6');
      const headingText = headingElement ? headingElement.textContent.trim() : 'No heading';

      // console.log('headingText:', headingText);

      dataLayer.push({
        event: 'slider_click',
        event_label: headingText
      });
    });

    // If there is a controlled slider, set it up here
    if (options?.controlSlider) {
      let controlledSliders = [];

      if (Array.isArray(options.controlSlider)) {
        controlledSliders = options.controlSlider.map((selector) =>
          document.querySelector(selector)
        );
      } else {
        controlledSliders.push(document.querySelector(options.controlSlider));
      }

      const swiperControlledInstances = controlledSliders.map((controlledSlider) => {
        const controlledSliderOptions =
          controlledSlider?.dataset.swiper &&
          JSON.parse(controlledSlider.dataset.swiper);

        return new Swiper(controlledSlider, controlledSliderOptions);
      });

      swiper.controller.control = swiperControlledInstances;
    }
  });
})();

